import classNames from 'classnames'
import { useState } from 'react'
import type { BookingLogoProps } from './booking-logo.interface'
import classes from './booking-logo.module.scss'

export function BookingLogo({ logoUrl, alt, fallback, className }: BookingLogoProps) {
  const [failedUrl, setFailedUrl] = useState<string | null>(null)

  if (!logoUrl || failedUrl === logoUrl) return <>{fallback}</>

  return (
    <img
      src={logoUrl}
      alt={alt}
      className={classNames(classes.logo, className)}
      onError={() => setFailedUrl(logoUrl)}
    />
  )
}
